import React, { PureComponent } from 'react';
import styles from './index.css';

/**
 * 提示：鼠标移入事件显示的二维码
 */
class MouseCodeImg extends PureComponent {

  render() {

    const { qrImgContent } = this.props;
    const qrImgSrc = 'https:' + qrImgContent;

    return (
      <div className={styles.outerPcMaskMouse}>
        <img className={styles.imgMouse} src={qrImgSrc} alt="手机客户端二维码"/>
        <span className={styles.sjsmPc}>手机扫描二维码观看</span>
      </div>
      );
  }
}

export default MouseCodeImg;
